import { Box, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import FloatingSidebar from "./FloatingSidebar";
import Appbar from "./Appbar";
import { AddOutlined } from "@mui/icons-material";
import { colors } from "../theme/theme";

const Layout = ({
  children,
  heading,
  hideSideBar,
  btnText,
  onCreate,
  noBtn,
}) => {
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [sidebarOpen, setSidebarOpen] = useState(mdScreen ? false : true);
  const sidebarWidth = sidebarOpen ? 260 : 80;

  return (
    <>
      <FloatingSidebar
        open={sidebarOpen}
        toggleSidebar={setSidebarOpen}
        hideSideBar={hideSideBar}
      />

      <Box
        sx={{
          height: "100vh",
          overflow: "auto",
          backgroundImage: `url(${require("../assets/images/bg-image1.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          transition: "padding-left 0.3s ease",
          pl: smScreen ? "0px" : `${sidebarWidth + 40}px`,
        }}
      >
        <Box
          sx={{
            padding: 3,
            transition: "all 0.3s ease",
            minWidth: 0,
          }}
        >
          <Appbar
            heading={heading}
            btnText={btnText}
            onCreate={onCreate}
            open={sidebarOpen}
            toggleSidebar={setSidebarOpen}
            noBtn={noBtn}
          />
          {children}
        </Box>
      </Box>
      {smScreen && onCreate && (
        <Box
          onClick={onCreate}
          sx={{
            position: "absolute",
            bottom: "5%",
            right: "5%",
            zIndex: 1000,
            backgroundColor: "white",
            borderRadius: "50%",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
        >
          <AddOutlined sx={{ color: colors.secondary, fontSize: "30px" }} />
        </Box>
      )}
    </>
  );
};

export default Layout;
